export const PRODUCT_CONFIGURATOR_RECEIVE = 'PRODUCT_CONFIGURATOR_RECEIVE';
export const PRODUCT_CONFIGURATOR_SEND = 'PRODUCT_CONFIGURATOR_SEND';
export const PRODUCT_CONFIGURATOR_UPDATE = 'PRODUCT_CONFIGURATOR_UPDATE';
export const PRODUCT_CONFIGURATOR_ERROR = 'PRODUCT_CONFIGURATOR_ERROR';
